'use client';

import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import useCurrentRoute from '@/app/[locale]/product/_components/HardwarePDP/_hooks/useCurrentRoute';
import getPdpWizardSeoMetadata from '@/app/[locale]/product/rings/_utils/getPdpWizardSeoMetadata';
import type { PageParams } from '@/app/[locale]/product/rings/oura-ring-4/(wizard)/_types/pageParams';
import { RingStyleEnum } from '@/app/enums/RingStyleEnum';
import { usePartnerCode } from '@/app/hooks/usePartnerCode';
import usePartnerUtm from '@/app/hooks/usePartnerUtm/usePartnerUtm';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import OR4PDPContent from './OR4PDPContent';

export const OR4PDPPage = (params: PageParams) => {
  const t = useTranslations();
  const currentRoute = useCurrentRoute({
    locale: params.locale,
  });

  // Update the document title based on the current route
  useEffect(() => {
    if (!currentRoute.finish.value) return;
    const { title } = getPdpWizardSeoMetadata(
      RingStyleEnum.OuraRing4,
      currentRoute.finish.value,
    );
    document.title = t(title);
  }, [currentRoute.finish.value, t]);

  // Persist UTM query param data to localStorage (if any params exist)
  usePartnerUtm();

  // Persist partner code query param if exists
  usePartnerCode();

  useScrollTracking();

  return <OR4PDPContent {...params} />;
};

export default OR4PDPPage;
